import { render, staticRenderFns } from "./AndamentosOuvidoria.vue?vue&type=template&id=523094b2&scoped=true"
import script from "./AndamentosOuvidoria.vue?vue&type=script&lang=ts"
export * from "./AndamentosOuvidoria.vue?vue&type=script&lang=ts"
import style0 from "./AndamentosOuvidoria.vue?vue&type=style&index=0&id=523094b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523094b2",
  null
  
)

export default component.exports